export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_125_ACTIVE': 'Active',
    '_7154_ACTIVE_USERS': 'Active Users',
    '_7159_ADD_PARAMETERS': 'Add Parameters',
    '_109_ALL': 'All',
    '_7156_ALL_USERS': 'All Users',
    '_935_AN_ERROR_OCCURRED_WHILE_PROCESSING_YOUR_SEARCH__PLEASE_TRY_AGAIN_': 'An error occurred while processing your search. Please try again.',
    '_148_AREA': 'Area',
    '_7437_BOTH': 'Both',
    '_7363_CLEAR': 'Clear',
    '_763_CLOSE': 'Close',
    '_126_DEACTIVE': 'Deactive',
    '_7155_DEACTIVE_USERS': 'Deactive Users',
    '_818_FETCHING_YOUR_DATA__PLEASE_WAIT_': 'Fetching Your Data. Please wait.',
    '_853_FIRST_NAME_OR_LAST_NAME': 'First Name or last name',
    '_7160_INACTIVE': 'Inactive',
    '_7157_INCLUDES': 'Includes',
    '_583_LOB': 'LOB',
    '_48_MANAGER': 'Manager',
    '_50_MANAGER_NAME': 'Manager Name',
    '_53_NAME': 'Name',
    '_94_NO_RESULTS': 'No Results',
    '_7161_NO_USERS_WERE_FOUND__PLEASE_MODIFY_YOUR_SEARCH_CRITERIA_AND_TRY_AGAIN__IF_YOU_CONTINUE_EXPERIENCING_PROBLEMS__IT_COULD_BE_DUE_TO_PERMISSIONS_OR_INCORRECT_USER_CONFIGURATION___PLEASE_CONTACT_YOUR_SYSTEM_ADMINISTRATOR_': 'No users were found, please modify your search criteria and try again. If you continue experiencing problems, it could be due to permissions or incorrect user configuration - please contact your system administrator.',
    '_149_REGION': 'Region',
    '_7158_REMOVE': 'Remove',
    '_59_ROLE': 'Role',
    '_710_SEARCH': 'Search',
    '_97_SEARCH_RESULTS': 'Search Results',
    '_98_SEARCH_USER': 'Search User',
    '_7153_SEARCH_USERS': 'Search Users',
    '_99_SELECT': 'Select',
    '_974_SELECT_A_REGION': 'Select a Region',
    '_647_SELECT_A_ROLE': 'Select a Role',
    '_652_SELECT_A_SITE': 'Select a Site',
    '_834_SELECT_A_SUPERGROUP': 'Select a SuperGroup',
    '_657_SELECT_A_USER': 'Select a User',
    '_976_SELECT_AN_AREA': 'Select an Area',
    '_64_SITE': 'Site',
    '_127_STATUS': 'Status',
    '_67_SUPERGROUP': 'SuperGroup',
    '_85_SYSTEM_ID': 'System ID',
    '_938_THESE_SEARCH_CRITERIA_RESULTED_IN_MORE_THAN_THE_50_RECORDS_DISPLAYED_HERE__PLEASE_NARROW_YOUR_CRITERIA_AND_SEARCH_AGAIN_IF_YOU_DO_NOT_SEE_THE_RECORD_YOU_ARE_LOOKING_FOR_': 'These search criteria resulted in more than the 50 records displayed here. Please narrow your criteria and Search again if you do not see the record you are looking for.',
    '_101_USER_ID': 'User ID',
    '_102_USER_NAME': 'User Name',
    '_640__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_ENTER_A__FIELD_LABEL_': '{{field_label}} is a required field. Please enter a {{field_label}}.',
    '_1_NONE': 'None',
    '_9736_INDIVIDUAL_SELECTED': 'Individual Selected',
    '_9737_YOUR_FAVOURITES': 'Your Favourites',
    '_9738_CLEAR_ALL': 'Clear all',
    '_9739_FINISH_USER_SELECTION': 'Finish User Selection',
    '_9740_DIRECT_REPORTS': 'Direct Reports',
    '_7409_DEFAULT_VIEW__SELF_': 'Default View (self)'
};
